import { hotGossips } from "@/mocks/gossip";

export default function HotGossip() {
  const [featured, ...rest] = hotGossips;

  return (
    <section id="hot" className="bg-background-50 py-16 md:py-24">
      <div className="shell">
        <div className="flex flex-col gap-4 border-b border-background-200 pb-6 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-medium uppercase tracking-[0.2em] text-primary-600">Hot Now</span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">今日热瓜</h2>
            <p className="mt-2 text-sm text-foreground-600">按当前讨论热度排序，实时刷新中</p>
          </div>
          <a
            href="#feed"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部爆料
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1.6fr_1fr]">
          <article className="group relative overflow-hidden rounded-lg">
            <div className="h-[300px] w-full overflow-hidden md:h-[440px]">
              <img
                src={featured.image}
                alt={`${featured.title}相关配图`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/45 to-transparent" aria-hidden="true" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <span className="inline-flex items-center gap-1.5 rounded-sm bg-primary-500 px-2 py-1 text-[11px] font-medium text-background-50">
                <i className="ri-fire-fill" aria-hidden="true" />
                {featured.category}
              </span>
              <h3 className="mt-3 font-heading text-xl leading-snug text-background-50 md:text-3xl">{featured.title}</h3>
              <p className="mt-3 hidden max-w-2xl text-sm leading-7 text-background-100/80 sm:block">{featured.excerpt}</p>
              <p className="mt-4 flex items-center gap-4 text-xs text-background-100/65">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-time-line" aria-hidden="true" />
                  {featured.time}
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-eye-line" aria-hidden="true" />
                  {featured.reads} 阅读
                </span>
              </p>
            </div>
          </article>

          <div className="flex flex-col gap-4">
            {rest.map((item, index) => (
              <article
                key={item.id}
                className="group flex flex-1 gap-4 rounded-lg border border-background-200 bg-background-100/70 p-3 transition-colors hover:border-primary-200 hover:bg-primary-50/60 md:p-4"
              >
                <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md md:h-24 md:w-28">
                  <img
                    src={item.image}
                    alt={`${item.title}相关配图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-heading text-base text-primary-500">0{index + 2}</span>
                    <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-800">{item.category}</span>
                  </div>
                  <h3 className="mt-2 text-sm font-medium leading-6 text-foreground-900 transition-colors group-hover:text-primary-700 md:text-base">
                    {item.title}
                  </h3>
                  <p className="mt-2 flex items-center gap-3 text-[11px] text-foreground-500">
                    <span>{item.time}</span>
                    <span>{item.reads} 阅读</span>
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}